import { Center, Container, Image } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

import { isTestingEnvironment } from '../helpers/environments';
import { DebuggingBanner } from './DebuggingBanner';

type PublicPageLayoutProps = {
  children?: ReactNode;
};

export const PublicPageLayout: FC<PublicPageLayoutProps> = ({ children }) => {
  return (
    <Container padding="10">
      <Center pb={'30'}>
        <Image src="/images/oe-service-logo-black.svg" alt="oe service logo" h={14} w={'auto'} />
      </Center>
      {isTestingEnvironment() ? <DebuggingBanner /> : null}
      {children}
    </Container>
  );
};
